import React from 'react';
import { useTranslation } from 'react-i18next';
import GetAppIcon from '@material-ui/icons/GetApp';
import { NAME_SPACE } from 'i18n';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { useButtonStyles } from '../button.styles';

export function PackagingButtonDownloadFile({ onClick, tooltip }) {
  const { t } = useTranslation(NAME_SPACE.COMMON);
  const classes = useButtonStyles();

  return (
    <Button
      text={t('actions.download')}
      className={classes.buttonDownloadStyles}
      onClick={onClick}
      tooltip={tooltip && { ...tooltip, title: tooltip.title || t('actions.download') }}
      icon={<GetAppIcon />}
    />
  );
}

PackagingButtonDownloadFile.propTypes = {
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.object
};
